export default {
    customer: {
        changePlan: {
            step1: 'Escolha o Plano',
            step2: 'Escolha os módulos e aplicativos opcionais',
            step3: "Escolha os App's de Fornecedores",
            thirdPartyApps: 'Aplicativos de Parceiros',
            nextStep: 'Avançar',
            prevStep: 'Voltar',
            save: 'Salvar',
            selectAPlan: 'Selecione um plano para continuar',
            configurations: 'Configurações',
        },
        block: {
            title: 'Confirmar Bloqueio ?',
            text:
                '<p>O acesso do cliente <strong>{name}</strong> será bloqueado, porém o mesmo continuará sendo cobrado.</p><p>Tem certeza que deseja continuar?</p>',
            success: 'Cliente <strong>{name}</strong> bloqueado com sucesso.',
        },
        unblock: {
            title: 'Confirmar Desbloqueio ?',
            text:
                '<p>Tem certeza que deseja desbloquear o cliente <strong>{name}</strong>?</p>',
            success:
                'Cliente <strong>{name}</strong> desbloqueado com sucesso.',
        },
        requestCancellation: {
            title: 'Solicitar cancelamento',
            text: 'Tem certeza que deseja solicitar o cancelamento do cliente',
            decline: 'Fechar',
            confirm: 'Confirmar',
            success: 'Solicitação de cancelamento realizada com sucesso',
        },
    },
}
